import React, { useEffect, useState } from 'react';
import CourseContent from './components/CourseContent';
import VideoPlayer from './components/VideoPlayer';
import CourseTabs from './components/CourseTabs';
import Overview from './components/Overview';
import CourseMaterial from './components/CourseMaterial';
import QuizSection from './components/QuizSection';
import RelatedCourses from './components/RelatedCourses';
import './style.css'
import { useParams } from 'react-router-dom';
import { completeVideo, getCoursesById } from '../../../services/Staff/Staff';
const Index = () => {
  const instructor = {
    name: "Dr. Sarah",
    title: "Role",
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    bio: "Dr. Sarah Wilson has over 15 years of experience in aesthetic medicine and skincare. She has trained hundreds of clinicians worldwide and is passionate about sharing her knowledge with aspiring beauty professionals."
  };
  const initialcourseModules = [
    {
      id: 1,
      title: "Welcome to The Beauty Clinic",
      completed: true,
      videoUrl: "https://www.youtube.com/embed/rsWAK61rTVI"
    },
    {
      id: 2,
      title: "The Philosophy of Beauty",
      completed: false,
      videoUrl: "https://www.youtube.com/embed/668nUCeBHyY"
    },
    {
      id: 3,
      title: "Aesthetic Treatments 101",
      completed: false,
      videoUrl: "https://www.youtube.com/embed/es4x5R-rV9s"
    },
    {
      id: 4,
      title: "Skincare Essentials",
      completed: false,
      videoUrl: "https://www.youtube.com/embed/i761hUg3dUw"
    },
    {
      id: 5,
      title: "Your Personalized Beauty Plan",
      completed: false,
      videoUrl: "https://www.youtube.com/embed/gJntKcGKsB4"
    },
    {
      id: 6,
      title: "Real Client Transformations",
      completed: false,
      videoUrl: "https://www.youtube.com/embed/rsWAK61rTVI"
    },
    {
      id: 7,
      title: "FAQs & Final Thoughts",
      completed: false,
      videoUrl: "https://www.youtube.com/embed/rsWAK61rTVI"
    }
  ];

const getInitials = (name) => {
        return name ? name.charAt(0).toUpperCase() : "U"
    }
  // State for currently active module and tab
  const [courseModules, setCourseModules] = useState()
  const [activeModule, setActiveModule] = useState();
  const [activeTab, setActiveTab] = useState('overview');
  const { id } = useParams();
  const [courseContent , setCourseContent] = useState()
  const [quizLocked , setQuizLocked] = useState(true);
  const [loading , setLoading] = useState(true);

    const fetchData = async () => {
      setLoading(true)
       let data = await getCoursesById(id);
       if(data){
        console.log("data>>><<<<<<<",data)
        setCourseModules(data?.data?.content?.videos)
        setActiveModule(data?.data?.content?.videos[0])
        setCourseContent(data?.data)
        setQuizLocked(data?.data?.content?.quizLocked)
       }
      setLoading(false)

    }
    useEffect(()=>{
       fetchData()
    },[])


  // Function to handle video end
  const handleVideoEnd = async () => {
    console.log("Video ended - API call would go here",courseModules);
    // Find the next module
    const payload = {
    courseId:id,
    videoId:activeModule._id
}
    let data = await completeVideo(payload);
    if(data?.success){
     const updatedModules = courseModules.map(module =>
      module._id === activeModule._id
        ? { ...module, isCompleted: true }
        : module
    );
    setCourseModules(updatedModules);
    const currentIndex = courseModules.findIndex(module => module._id === activeModule._id);
    if (currentIndex < courseModules.length - 1) {
      setActiveModule(courseModules[currentIndex + 1]);
    }
    console.log("setQuizLocked",data)
    if (!data?.quizLocked) {
      setQuizLocked(false)

}
    }
  
    
  };

  // Function to render the active tab content
  {
    console.log("courseContent?.content?.quizes",courseContent?.content?.quizes)
  }
  const renderActiveTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview description = {courseContent?.course?.description}/>;
      case 'courseMaterial':
        return <CourseMaterial courseContent={courseContent}/>;
      case 'quizSection':
        return <QuizSection 
        questions={courseContent?.content?.quizes} 
        courseId= {courseContent?.course?._id}
        viewMode={false}
        submittedAnswers={[
          {
            quizId: "6849f6af2863cb9a085a8d09",
            answer: "option 1" 
          },
          {
            quizId: "6849f6af2863cb9a085a8d0a",
            answer: "option 4" 
          },
          {
            quizId: "6849f6af2863cb9a085a8d0b",
            answer: "option 3" 
          }
        ]}
        fetchData={fetchData}
        />;
      default:
        return <Overview />;
    }
  };

  return (
    // <div className="container-fluid">
    
    <div className="row course-container">
      {
         loading ?
        <div className="col-md-12" style={{height:'40vh' , display:'flex',justifyContent:'center',alignItems:'center'}}>
          <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
        :
        <>
        <div className=" p-0" style={{ width: "29.17%" }}>
        <div className="course-content-sidebar">
          <h3 className="mb-4">Course Content</h3>
          {
            courseModules &&
            <CourseContent
            modules={courseModules}
            activeModule={activeModule}
            onModuleSelect={setActiveModule}
          />
          }
         
        </div>
      </div>

      {/* Main Content */}
      <div className=" " style={{ width: "70.83%" }}>
        {/* Video Player */}
        <div className=" " style={{ backgroundColor: 'black', height: '400px' }}>
          <div className='px-3'>
            <VideoPlayer videoUrl={activeModule?.videoUrl} onVideoEnd={handleVideoEnd} />
          </div>
        </div>

        {/* Tabs and Content */}
        <div className="bg-white">
          <CourseTabs activeTab={activeTab} onTabChange={setActiveTab} isLocked={quizLocked}/>

        </div>
        {/* <div class="spinner-border spinner-border-sm" role="status"></div> */}
        <div className='d-flex bg-white'>


          <div className=" " style={{width:'62.5%'}}>
            <div className="instructor-container">

              <div className=''>
                <b>Instructor</b>
                <div className='d-flex align-items-center mt-1'>
                  {
                    courseContent?.instructor?.profileImageUrl ?
                  <img src={`${process.env.REACT_APP_BUCKET_URL}${courseContent?.instructor?.profileImageUrl}`} 
                  alt={instructor.name} className="instructor-image" />

                    :
                <div
                           className="instructor-image bg-secondary d-flex align-items-center justify-content-center text-muted fw-bold"
                            style={{  fontSize: '26px' }}
                          >
                            {getInitials(courseContent?.instructor?.fullName || "")}
                   </div>
                  }
                  <div>
                    <h5>{courseContent?.instructor?.fullName}</h5>
                    <p className="text-muted">{courseContent?.instructor?.role}</p>
                  </div>
                </div>
              </div>
             
              <div className='d-flex'>
                <div className='custom-border-left'>
                </div>
                {/* <p className="text-muted ">Related to this course</p> */}
                <div class="course-section  ">
                  <p class="course-section-heading ">Related to this course</p>

                  <p className='course-section-sub-heading'>
                    Certificate
                  </p>

                  {/* <button className="course-material-btn">
                    Course Material
                  </button> */}

                  <div
        className={`course-material-btn ${activeTab === 'courseMaterial' ? 'active' : ''}`}
        onClick={() => setActiveTab('courseMaterial')}
      >
        Course Material
        
      </div>
                </div>
              </div>
            </div>
            {/* <p>{instructor.bio}</p> */}

            {renderActiveTabContent()}
          </div>

          {/* Related Courses (shown on all tabs) */}
          <div className=" mt-4" style={{width:'37.5%'}}>
            <RelatedCourses  relatedCourses={courseContent?.relatedCourses}/>
          </div>
        </div>
      </div>
        
        </>
      }
      {/* Course Content Sidebar */}
      
    </div>
    // </div>
  );
};

export default Index;